import { notification as notificationAntd } from 'antd';

const notification = {
    success: message => notificationAntd.success({ message, duration: 6 }),
    error: message => notificationAntd.error({ message, duration: 6 }),
    warning: message => notificationAntd.warning({ message, duration: 6 }),
};
export default notification;